<template>
  <div id="app" style="overflow: hidden;">
    <!-- 页头 -->
    <!-- <nav-header2></nav-header2> -->
    <!-- <side-bar></side-bar> -->
    <router-view ></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style>
.el-dialog__title{
  font-size: 14px !important;
    font-weight: 700 !important;
    color: #333 !important;
}
.el-form-item__label{
  position: relative;
}
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
  position: absolute;
    right: 0px;
}
.el-form-item__label{
  color: #333 !important;
  font-size: 12px !important;
}
</style>
